import React, { useEffect, useState, useRef } from "react";
import {
  Layout,
  Space,
  Button,
  PageHeader,
  Modal,
  Table,
  Switch,
  Card,
  Form,
  Input,
  message,
} from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import PaymentService from "../../../services/PaymentService";
import square from "../../../assets/images/square.svg";

const { Content } = Layout;

const ConfigureTerminals = ({ setView,terminalCardReader }) => {
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("TERMINAL");
  const [terminalList, setTerminalList] = useState([
    // {
    //   id: 1,
    //   restaurant_id: 123,
    //   terminal_name: "Terminal A",
    //   device_code: "ABC123",
    //   location_id: "XYZ789",
    //   is_active: true,
    //   is_online: true,
    //   online_status: "online",
    //   device_type: "TERMINAL",
    // },
    // {
    //   id: 2,
    //   restaurant_id: 456,
    //   terminal_name: "Card Reader X",
    //   device_code: "DEF456",
    //   location_id: "LMN012",
    //   is_active: false,
    //   is_online: false,
    //   online_status: "offline",
    //   device_type: "CARD_READER",
    // },
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditData, setIsEditData] = useState({});
  const filteredTerminal = useRef([]);

  const [isConnected, setIsConnected] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    getTerminalAndCardReaders(terminalCardReader[0]?.id);
    getfilteredTerminal();
  }, [terminalCardReader]);

  const getfilteredTerminal = () => {
    if(filteredTerminal)
    filteredTerminal.current = terminalList?.filter(
      (item) => item.device_type == selectedTab
    );
  };

  useEffect(() => {
    getfilteredTerminal();
  }, [selectedTab]);

  const getTerminalAndCardReaders = async (id) => {
    const response = await PaymentService.getTerminalAndCardReader(id);
    if(response && response?.length>0)
    setTerminalList(response)
  };

  const onActive = async (data, value) => {
    let id = data.id;
    data.is_active = value;
    delete data.id;
    delete data.restaurant_id;
    const response = await PaymentService.updateTerminalAndCardReader(data, id);
  };

  const onEdit = async (data) => {
    setIsEditData(data);
    form.setFieldsValue(data);
    setIsModalOpen(true);
  };

  const onDelete = async (data) => {
    const response = await PaymentService.deleteTerminalAndCardReader(data.id);
  };

  const onFinish = async (data) => {
    data.device_code = "ABC123";
    data.online_status = "online";
    data.device_type = selectedTab;
    if (Object.keys(isEditData).length === 0) {
      const response = await PaymentService.createTerminalAndCardReader({name:data?.terminal_name},terminalCardReader);
      if(response)
      {
        message.success("successfully paired");
        getfilteredTerminal();
      }
      else{
        message.error("please try later")
      }
      setIsModalOpen(false);
    } else {
      const response = await PaymentService.updateTerminalAndCardReader(
        data,
        isEditData.id
      );
    }
  };

  const onModelClose = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  return (
    <Layout className="u-page-layout">
      <Content>
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader
            style={{ minHeight: 80 }}
            className="d-flex items-center page-header-business"
            extra={[
              <div
                style={{ textDecoration: "underline" }}
                className="theme-red img-btn mr-1"
                onClick={() => setIsModalOpen(true)}
              >
                {terminalList.length > 0 ? "+ Add New Terminal" : ""}
              </div>,
              <div className="button-div">
                <Button
                  className={
                    selectedTab === "TERMINAL"
                      ? "selected-tab-button custom-btn"
                      : "button-grp-border default-button custom-btn"
                  }
                  type="primary"
                  onClick={() => {
                    setSelectedTab("TERMINAL");
                  }}
                >
                  Terminals
                </Button>
                <Button
                  className={
                    selectedTab === "CARD_READER"
                      ? "selected-tab-button custom-btn"
                      : "button-grp-border default-button custom-btn"
                  }
                  type="primary"
                  onClick={() => {
                    setSelectedTab("CARD_READER");
                  }}
                >
                  Card Readers
                </Button>
              </div>,
            ]}
            title={
              <div className="flex items-center">
                <div
                  className="cursor-pointer flex"
                  onClick={() => setView("payment")}
                >
                  <svg
                    width="25"
                    height="16"
                    viewBox="0 0 25 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM25 7L1 7V9L25 9V7Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div className="ml-1 ant-page-header-heading-title">
                  Configure Terminals
                </div>
              </div>
            }
          />
          <div className="content-container-business">
            <div className="qr-table">
              {terminalList.length === 0 ? (
                <Card className="card-qr add-terminal">
                  <div style={{ fontSize: 18, color: "rgba(58, 58, 58, 0.6)" }}>
                    You have not configured any terminal yet. Link one now!
                  </div>
                  <div className="mt-2">
                    <Button
                      type="dashed"
                      className="theme-red"
                      style={{ width: 100, height: 100, padding: 0 }}
                      onClick={()=>setIsModalOpen(true)}
                    >
                      <PlusOutlined style={{ fontSize: 40 }} />
                    </Button>
                  </div>
                </Card>
              ) : (
                <Table
                  dataSource={filteredTerminal?.current}
                  pagination={false}
                  columns={[
                    {
                      title: "Terminal Name",
                      render: (e, record) => (
                        <div className="table-row-div">
                          {record.terminal_name}
                        </div>
                      ),
                    },
                    {
                      title: "Location ID",
                      render: (e, record) => (
                        <div className="table-row-div">
                          {record.location_id}
                        </div>
                      ),
                    },
                    {
                      title: "Online Status",
                      render: (e, record) => (
                        <div className="table-row-div">
                          {record.is_online ? "ACTIVE" : "NOT ACTIVE"}
                        </div>
                      ),
                    },
                    {
                      title: "Turn on/off",
                      render: (e, record) => (
                        <div className="table-row-div">
                          <Switch
                            defaultValue={record.is_active}
                            onChange={(value) => onActive(record, value)}
                          />
                        </div>
                      ),
                    },
                    {
                      title: "Action",
                      render: (e, record) => (
                        <div className="table-row-div">
                          <a className="mr-1" onClick={() => onEdit(record)}>
                            <EditOutlined />
                          </a>
                          <a onClick={() => onDelete(record)}>
                            <DeleteOutlined />
                          </a>
                        </div>
                      ),
                    },
                  ]}
                />
              )}
            </div>
          </div>
        </Space>
        <Modal
          open={isModalOpen}
          footer={null}
          onCancel={() => onModelClose()}
          title={
            <div className="flex items-center">
              <img src={square} alt="check" className="modal-header-icon" />
              <div className="modal-header-text">Terminal</div>
            </div>
          }
        >
          <div className="modal-head">Authorize FoodLuv POS in square</div>

          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="Name of the Terminal"
              tooltip="Name of the Terminal"
              name="terminal_name"
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Location ID"
              tooltip="Location ID"
              name="location_id"
            >
              <Input />
            </Form.Item>

            <Form.Item>
              <div className="flex justify-center">
                {!isConnected && (
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="custom-btn"
                  >
                    Connect
                  </Button>
                )}
              </div>
            </Form.Item>
          </Form>
          {isConnected && (
            <div
              className="flex justify-center"
              style={{ flexDirection: "column" }}
            >
              <div>Enter the below Device code in your Square Terminal</div>
              <div className="theme-red mt-1" style={{ fontSize: 20 }}>
                BTYND23
              </div>
            </div>
          )}
        </Modal>
      </Content>
    </Layout>
  );
};

export default ConfigureTerminals;
